import { createContext, useContext } from "react";

export function createCtx<T>() {
  const ctx = createContext<T | undefined>(undefined);

  const useCtx = () => {
    const context = useContext(ctx);
    if (!context) {
      throw new Error("useCtx must be used within its Provider");
    }
    return context;
  };

  return [useCtx, ctx.Provider] as const;
}
